module.exports = __webpack_public_path__ + "72dc31e514bd53b4c6852b2f781ad23b.png";